import "./ChecklistGroup.css";
import IconText from "./IconText";
import { Sparkles } from "./icons";

export default function ChecklistGroup({
  items = [],
  children,
  icon = Sparkles,
  variant = "warning",
  size = "sm",
  iconSize = 16,
  className = "",
}) {
  return (
    <div className={`ui-checklist-group ${className}`}>
      {items.map((item, index) => {
        const text = typeof item === "string" ? item : item.text;
        const ItemIcon = typeof item === "object" && item.icon ? item.icon : icon;
        const itemVariant =
          typeof item === "object" && item.variant ? item.variant : variant;

        return (
          <IconText
            key={`${text}-${index}`}
            icon={ItemIcon}
            variant={itemVariant}
            size={size}
            iconSize={iconSize}
            align="start"
          >
            {text}
          </IconText>
        );
      })}

      {children}
    </div>
  );
}
